export default __webpack_public_path__ + "static/media/3041.8f890db4.jpg";